<template>
	<div class="main" style="padding: 20px 20px;">
		<div style="text-align: right;"><el-button @click="goIndex">去填报</el-button></div>
		<div class="main_top">
			<div class="title_top">
				<div>填报流程</div>
				<div class="steps">
					<!-- <el-steps :active="this.activities[0].dyAuditStatus" align-center>
						<el-step title="提交信息" description=""></el-step>
						<el-step title="初审" :description="this.activities[0].dyAuditStatus<2?this.activities[0].auditMessage:''"
							:status="this.activities[0].dyAuditStatus<2 ? getStatus() : ''"></el-step>
						<el-step title="终审" :description="this.activities[0].dyAuditStatus>=2 ? this.activities[0].auditMessage:''" 
						:status="this.activities[0].dyAuditStatus>=2 ? getStatus() : ''"></el-step>
						<el-step title="入驻成功" description=""></el-step>
					</el-steps> -->
					<el-steps :active="4" align-center>
						<el-step title="提交信息" description=""></el-step>
						<el-step title="初审"></el-step>
						<el-step title="终审"></el-step>
						<el-step title="入驻成功" description=""></el-step>
					</el-steps>
				</div>
			</div>
		</div>
		<div class="main_bottom">
			<el-table v-loading="loading" v-if="activities.length > 0" :data="activities" style="width: 100%" border>
				<el-table-column fixed prop="id" label="编号" width="100"></el-table-column>
				<el-table-column prop="fullName" label="商户名称" width="300"></el-table-column>
				<el-table-column prop="licenseId" label="营业执照编号" width="200"></el-table-column>
				<el-table-column prop="certificateName" label="法人" width="100"></el-table-column>
				<el-table-column prop="shortName" label="商户简称" width="200"></el-table-column>
				<el-table-column prop="linkMan" label="商户联系人" width="100"></el-table-column>
				<el-table-column prop="contactPhoneNum" label="联系人手机号" width="150"></el-table-column>
				<el-table-column prop="bankBranchName" label="银行支行名称" width="220"></el-table-column>
				<el-table-column prop="dyAuditStatus" label="提交状态" width="100">
					<template slot-scope="scope">
						<el-tag v-if="scope.row.dyAuditStatus!=7">已提交</el-tag>
						<el-tag v-else>未提交</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="dyAuditStatus" label="报单状态" width="150">
					<template slot-scope="scope">
						<el-tag v-if="scope.row.dyAuditStatus==0">初审中</el-tag>
						<template>
							<div style="display: flex;align-items: center;gap: 2px;" v-if="scope.row.dyAuditStatus==1">
								<el-tag type="danger">初审驳回</el-tag>
								<el-tooltip class="item" effect="dark" :content="activities[0].auditMessage"
									placement="top-start">
									<span class="pumMessage">?</span>
								</el-tooltip>
							</div>
						</template>
						<el-tag v-if="scope.row.dyAuditStatus==2">终审中</el-tag>

						<template>
							<div style="display: flex;align-items: center;gap: 2px;" v-if="scope.row.dyAuditStatus==3">
								<el-tag type="danger">终审驳回</el-tag>
								<el-tooltip class="item" effect="dark" :content="activities[0].auditMessage"
									placement="top-start">
									<span class="pumMessage">?</span>
								</el-tooltip>
							</div>
						</template>
						<el-tag v-if="scope.row.dyAuditStatus==4">商户信息配置中</el-tag>
						<el-tag v-if="scope.row.dyAuditStatus==5" type="success">已完成</el-tag>
						<el-tag type="info" v-if="scope.row.dyAuditStatus==6">已撤回</el-tag>
						<el-tag v-if="scope.row.dyAuditStatus==7">待提交</el-tag>
						<el-tag v-if="scope.row.dyAuditStatus==8">初审完成</el-tag>
					</template>
				</el-table-column>
				<el-table-column fixed="right" prop="updatedAt" label="更新时间" width="200"></el-table-column>
				<el-table-column fixed="right" label="操作" width="300">
					<template>
						<!-- <el-button type="primary" size="mini" plain @click="btnLook('look')">查看</el-button> -->
						<el-button type="primary" size="mini" plain @click="btnRevocation"
							:disabled="this.activities[0].dyAuditStatus!=0">撤回</el-button>
						<el-button type="primary" size="mini" plain @click="btnLook('updata')"
							:disabled="this.activities[0].dyAuditStatus!=3 && this.activities[0].dyAuditStatus!=6 && this.activities[0].dyAuditStatus!=1">编辑</el-button>
						<el-button type="primary" size="mini" plain @click="btnSubmit"
							:disabled="this.activities[0].dyAuditStatus!=3 && this.activities[0].dyAuditStatus!=6 && this.activities[0].dyAuditStatus!=1">提审</el-button>
						<!-- <el-button type="primary" size="mini" plain @click="refresh">刷新数据</el-button> -->
					</template>
				</el-table-column>
			</el-table>
		</div>
		<el-dialog title="提示" :visible.sync="centerDialogVisible" width="30%" center style="padding: 0;">
			<div style="text-align: center;">
				<div>是否确定撤回审核?</div>
				<div>撤回后，无法进行报单流程!</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="centerDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="confirm">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		props: {
			value: {
				type: String,
				required: true
			}
		},
		watch: {
			value: {
				immediate: true, // 立即执行一次
				handler(newValue) {
					// 当 value 发生变化时调用 refresh 方法
					this.refresh();
				}
			}
		},
		data() {
			return {
				centerDialogVisible: false,
				activities: [],
				loading: true,
				id: 1,
			};
		},
		created() {
			if (this.$route.query.id == null) {
				this.$router.push('/home')
				return false
			} else {
				// this.refresh()
			}
		},
		methods: {
			goIndex() {
				this.$router.push('/index')
			},
			confirm() {
				this.$axios.post(`/open/v1/customers/${this.$route.query.id}/dy/recall`).then((res) => {
					if (res.data.code == 200) {
						this.$message({
							message: res.data.message,
							type: 'success'
						})
						this.refresh()
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						})
					}
				}).finally(() => {
					this.centerDialogVisible = false
				})
			},
			refresh() {
				this.loading = true
				this.$axios.get(`/open/v1/customers/${this.$route.query.id}/info`).then((res) => {
					if (res.data.code == 200 && res.data.data) {
						this.activities = []
						this.activities.push(res.data.data)
						this.$emit('success');
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						})
					}
				}).finally(() => {
					this.loading = false
				});
			},
			btnIndex() {
				this.$router.push('/index')
			},
			btnLook(type) {
				this.$router.push({
					path: '/updata',
					query: {
						type: type
					}
				})
			},
			btnSubmit() {
				this.$axios.post(`/open/v1/customers/${this.$route.query.id}/dy/reapplay`).then((res) => {
					if (res.data.code == 200) {
						this.$message({
							message: res.data.message,
							type: 'success'
						})
						this.refresh()
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						})
					}
				})
			},
			btnRevocation() {
				this.centerDialogVisible = true
			}
		},
	};
</script>

<style scoped>
	.title_top {
		text-align: center;
		margin-top: 20px;
		font-size: 20px;
		font-weight: bold;
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.steps {
		width: 70%;
		margin-top: 20px;
	}

	.el-step__title.is-process {
		font-size: 18px;
	}

	::v-deep .el-dialog--center .el-dialog__body {
		padding: 10px;
	}

	.pumMessage {
		width: 15px;
		height: 15px;
		border-radius: 50%;
		color: black;
		border: 1px solid black;
		display: flex;
		align-items: center;
		justify-content: center;
	}
</style>